import type { IContactVerificationScore } from './ContactVerificationScore.interface';
import ContactVerificationScoreItemIdSmart from './ContactVerificationScoreItemIdSmart';

export default class ContactVerificationScore implements IContactVerificationScore {
  idSmart: ContactVerificationScoreItemIdSmart;

  static build = (data: IContactVerificationScore) => new ContactVerificationScore(data);

  static blank = () => new ContactVerificationScore();

  /**
   * Constructor
   * @param {IContactVerificationScore} data
   */
  constructor(data?: IContactVerificationScore) {
    this.idSmart = data?.idSmart
      ? new ContactVerificationScoreItemIdSmart(data?.idSmart)
      : undefined;
  }
}
